import style from "@/styles/Quill.module.css";
import { Globe, Linkedin } from "lucide-react";

function SingleBlogAuthor({ blogData }) {
  const { firstName, lastName, extraData } = blogData.createdBy || {};
  const { authorBio, bioUrl, companyUrl, linkedinUrl } = extraData || {};
  return (
    <section>
      <div className="bg-gray-200/40 rounded-md lg:p-8 p-6  w-full">
        <div className="text-base">Author Detail</div>
        <span className="text-2xl font-semibold">
          {firstName + " " + lastName}
        </span>
        {authorBio && (
          <div className="mt-2">
            <div
              className={style.blogContent}
              id="mainContent"
              // style={{fontFamily:"Outfit"}}
              dangerouslySetInnerHTML={{
                __html: authorBio,
              }}
            />
          </div>
        )}
        {bioUrl && (
          <a href={bioUrl} target="_blank" rel="noreferrer">
            <span className="text-blue-500">Know more about {firstName}</span>
          </a>
        )}
        <div className="flex mt-4">
          {companyUrl && (
            <a
              href={companyUrl}
              target="_blank"
              rel="noreferrer"
              aria-label={companyUrl}
              className="bg-white p-2 text-lightGray rounded-full shadow-blr-box cursor-pointer mr-2
                flex items-center justify-center w-12 h-12  hover:bg-lightGray hover:text-white">
              <div>
                <Globe />
              </div>
            </a>
          )}
          {linkedinUrl && (
            <a
              href={linkedinUrl}
              target="_blank"
              rel="noreferrer"
              aria-label={linkedinUrl}
              className="bg-white p-2 text-lightGray rounded-full shadow-blr-box cursor-pointer mr-2
                flex items-center justify-center w-12 h-12  hover:bg-lightGray hover:text-white">
              <div>
                <Linkedin />
              </div>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}

export default SingleBlogAuthor;
